import React from 'react'
import { Row, Col, Form, Modal, Button, FormControl, Alert } from 'react-bootstrap'
import {findDOMNode} from 'react-dom'

class UserNewForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      employeeType: "client",
      clients: this.props.clients?this.props.clients:[],
      first_name: "",
      fNameError: "",
      last_name: "",
      lNameError: "",
      email: "" ,
      emailError: ""
    }
  }


  clientButtonClick(event) {
    $('.client-button').addClass('selected');
    $('.employee-button').removeClass('selected');
    $('.employee-only-fields').hide();
    this.setState({ employeeType: "client" });
  }

  employeeButtonClick(event) {
    $('.employee-button').addClass('selected');
    $('.client-button').removeClass('selected');
    $('.employee-only-fields').show();
    this.setState({ employeeType: "employee" });
  }

  toggleAccess(event) {
  }

  accessAll(event) {
    let checkAll = event.target.checked;
    $('.client-list input[type=checkbox]').each((index, el) => {
      $(el).prop("checked", checkAll)
    })
  }

  nextPage() {
    $(".page-1").hide();
    $(".page-2").show();
  }

  backPage() {
    $(".page-2").hide();
    $(".page-1").show();
  }

  searchClients(event) {
    let filter = event.target.value.toLowerCase().trim();
    let visibleClients = [];
    this.props.clients.forEach((client) => {
      let clientName = client.company_name.toLowerCase();
      if (clientName.includes(filter)) {
        visibleClients.push(client);
      }
    })
    this.setState({clients: visibleClients})
  }

  //=========================== FORM VALIDATION START ===================================
  handleSubmit = e => {
    e.preventDefault()
    const err = this.errorCheck()
    if (!err) {
         this.nextPage()
    }
   else {
     return
   }
  }

  errorCheck = () => {
    let isError = false
    const errors = {
      fNameError: "",
      lNameError: "",
      emailError: ""
    }

    if (this.state.first_name.length < 1) {
      isError = true
      errors.fNameError="First name cannot be empty"
    }

    if (this.state.last_name.length < 1) {
      isError = true
      errors.lNameError= "Last name cannot be empty"
    }


    if (this.state.email.indexOf("@") === -1 ) {
      isError = true
      errors.emailError = "Valid email must contain @ symbol"

    }
    if (isError){
    this.setState({
      ...this.state,
      ...errors
    })
  }
    return isError
  }

  change = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

//=========================== FORM VALIDATION END ===================================


  render() {
    const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

    return (
      <>
        <Button variant="success" onClick={(e) => this.setState({show: true})}>
          + Add user
        </Button>
        <Modal className="new-user-modal" show={this.state.show} onHide={(e) => this.setState({show: false})}>
          <Form className="new-user-form" action={this.props.createUserPath} method={this.props.pathMethod}>
            <input hidden name="authenticity_token" value={authenticityToken} readOnly />
            <div className="page-1">
              <Modal.Header closeButton>
                <Modal.Title>Add New User - Basic Info</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col>
                    <p>I want to add a new:</p>
                  </Col>
                </Row>
                <Row className="justify-content-center text-center">
                  <Col sm={12} md={6}>
                    <div className="client-button selected" onClick={(e) => {this.clientButtonClick(e)}}>
                      <i className="fas fa-broadcast-tower"></i>
                      <h3>Client</h3>
                    </div>
                    <Form.Control type="hidden" name="client" className="client-employee-field" value={this.state.employeeType == "client" ? "1" : "0"} />
                  </Col>
                  <Col sm={12} md={6}>
                    <div className="employee-button" onClick={(e) => {this.employeeButtonClick(e)}}>
                      <i className="far fa-user-circle"></i>
                      <h3>Employee</h3>
                    </div>
                    <Form.Control type="hidden" name="employee" className="dp-employee-field" value={this.state.employeeType == "employee" ? "1" : "0"} />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Control onChange={e => this.change(e)}  type="text" name="first_name" placeholder="First Name (required)" />
                      {this.state.fNameError ? (
                        <Alert variant="danger">{this.state.fNameError}</Alert>
                      ) : null}

                    </Form.Group>
                    <Form.Group >
                      <Form.Control onChange={e => this.change(e)} type="text" name="last_name" placeholder="Last Name (required)" />
                      {this.state.lNameError ? (
                        <Alert variant="danger">{this.state.lNameError}</Alert>
                      ) : null}
                    </Form.Group>
                    <Form.Group>
                      <Form.Control onChange={e => this.change(e)} type="email" name="email" placeholder="Email (required)" />
                      {this.state.emailError ? (
                        <Alert variant="danger">{this.state.emailError}</Alert>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} className="employee-only-fields" style={{"display": "none"}}>
                    <Form.Group>
                      <Form.Label>Employee Level:</Form.Label>
                      <Form.Control as="select" name="role">
                        <option value="Employee" default>Restricted</option>
                        <option value="Specialist">Standard</option>
                        <option value="Manager">Full</option>
                        <option value="Admin">Admin</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Employee Department:</Form.Label>
                      <Form.Control as="select" name="department">
                        <option value="None" default>None</option>
                        <option value="SEO">SEO</option>
                        <option value="PPC">PPC</option>
                        <option value="Both">SEO and PPC</option>
                        <option value="DEV">Development</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button style={{"backgroundColor": "#A3A3A3"}} onClick={(e) => this.setState({show: false})}>
                  Cancel
                </Button>
                <Button variant="info" onClick={this.handleSubmit}>
                  Continue to access
                </Button>
              </Modal.Footer>
            </div>
            <div className="page-2" style={{"display": "none"}}>
              <Modal.Header closeButton>
                <Modal.Title>Add New User - Account Access</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p onClick={this.backPage} className="back-btn text-info"><i className="fas fa-arrow-left pr-2"></i>Back to Basic Info</p>
                <div className="d-flex justify-content-between flex-wrap">
                  <div className="client-search">
                    <span className="fa fa-search"></span>
                    <input onChange={(e) => this.searchClients(e)} placeholder="Search accounts..." />
                  </div>
                  <div className="select-all">
                    <div className="custom-control custom-checkbox">
                      <input type="checkbox" onChange={(e) => {this.accessAll(e)}} className="custom-control-input" id='toggle-all-access' />
                      <label className="custom-control-label" htmlFor="toggle-all-access">Select All</label>
                    </div>
                  </div>
                </div>
                <Row>
                  <Col> 
                    <ul className="client-list">
                      {
                        this.state.clients.map((client) => {
                          return (
                            <li key={client.company_name}>
                              <Form.Group>
                                <div className="custom-control custom-checkbox">
                                  <input type="checkbox" onChange={(e) => {this.toggleAccess(e)}} name={`account_access_ids[${client.id}]`} className="custom-control-input" id={`account-access-id-${client.id}`} />
                                  <label className="custom-control-label" htmlFor={`account-access-id-${client.id}`}>{client.company_name}</label>
                                </div>
                              </Form.Group>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button style={{"backgroundColor": "#A3A3A3"}} onClick={(e) => this.setState({show: false})}>
                  Cancel
                </Button>
                <Button variant="secondary" type="submit">
                  Create user
                </Button>
              </Modal.Footer>
            </div>
          </Form>
        </Modal>
      </>
    );
  }
}

export default UserNewForm;
